
import RecordCircle from "../../../assets/outline/RecordCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RecordCircleIcon({ className, dataTestid = "RecordCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <RecordCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
